import { render, staticRenderFns } from "./SpecimenResultView.vue?vue&type=template&id=9f515c64&scoped=true&"
import script from "./SpecimenResultView.vue?vue&type=script&lang=js&"
export * from "./SpecimenResultView.vue?vue&type=script&lang=js&"
import style0 from "./SpecimenResultView.vue?vue&type=style&index=0&id=9f515c64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f515c64",
  null
  
)

export default component.exports